// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { DashboardEffects } from './store/effects';
import * as fromTask from './store/reducer';

// SERVICES
import {  DashBoardStoreService } from './dashboard-store.service';
import { DashBoardService } from './services/dashboard.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['dashboard'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure task ngrx related stuff.
 *
 *   @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 * Notes:-
 * Date: 19/05/-2020 Dashboard store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('Task', fromTask.reducer, { metaReducers }),
    EffectsModule.forFeature([DashboardEffects]),
  ],
  declarations: [],
  providers: [
    DashBoardService,
    DashBoardStoreService,
  ],
})
export class DashboardStoreModule { }
